import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';

function clickOnLearnMore() {
    const category = GA_EVENTS.crossSellInfoLightBox.category;
    const action = GA_EVENTS.crossSellInfoLightBox.actions.clickOnLearnMore;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function close() {
    const category = GA_EVENTS.crossSellInfoLightBox.category;
    const action = GA_EVENTS.crossSellInfoLightBox.actions.close;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function open(from) {
    const category = GA_EVENTS.crossSellInfoLightBox.category;
    const action = GA_EVENTS.crossSellInfoLightBox.actions.open;
    const label = `Opened from within ${from}`;

    setBehaviourEvent({ category, action, label });
}

export {
    clickOnLearnMore,
    close,
    open
};
